import { HoldCode } from '@/types/product-detail';
import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { ViewMoreMessage } from './view-more-message';
import { marked } from 'marked';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { Modal } from '../components';
import downloadFill from '@/assets/icons/download_fill.svg';
// import downloadOutline from '@/assets/icons/download-outline.svg';
import Image from 'next/image';
import Link from 'next/link';

interface IProps {
  holdCodes: HoldCode[];
  className?: string;
}

interface HoldCodeMessages {
  [key: string]: { message: string; enMessage: string }[];
}

export default function HoldCodeMessage(props: IProps) {
  const { holdCodes = [], className } = props;
  const [requiredMaterialModalVisible, setRequiredMaterialModalVisible] = useState(false);
  const { t: commonT, lang } = useLang(NAMESPACE.common);

  const holdCodeMessages: HoldCodeMessages = useMemo(() => {
    const formattedData = {};
    holdCodes.forEach((item) => {
      const { messageType, message, enMessage } = item;
      const formattedItem = { message, enMessage };
      if (!formattedData[messageType]) {
        formattedData[messageType] = [];
      }
      formattedData[messageType].push(formattedItem);
    });
    return formattedData;
  }, [holdCodes]);

  const onCloseModal = () => {
    setRequiredMaterialModalVisible(false);
  };

  const onHoldCodeClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).tagName === 'A' && (e.target as HTMLElement).id === 'hold_code_ep') {
      setRequiredMaterialModalVisible(true);
    }
  };

  return (
    <div className={classnames('flex flex-col', className)} onClick={onHoldCodeClick}>
      {Object.keys(holdCodeMessages).map((key) => (
        <ViewMoreMessage
          className="my-2"
          key={key}
          open={holdCodeMessages[key]?.length > 0}
          type={key === 'Warning' ? 'warning' : 'info'}
          title={key + ':'}
          messages={holdCodeMessages[key].map((item) => marked.parse(lang === 'en' ? item.enMessage : item.message))}
        />
      ))}
      {/* no need i18n */}
      <Modal
        isOpen={requiredMaterialModalVisible}
        isHiddenCancelButton
        saveButtonLabel={commonT('common.ok')}
        handleSave={onCloseModal}
        handleClose={onCloseModal}
      >
        <h3>购买者是经销商：</h3>
        <ol>
          <li>经办人的身份证正反面扫描件</li>
          <li>贵公司的危化证</li>
        </ol>
        <h3>购买者是终端用户：</h3>
        <ol>
          <li>经办人的身份证正反面扫描件</li>
          <li>
            合法用途说明 需盖章（如下模板）
            <Link href="/易制爆化学品使用备案证明模板.docx">
              <Image src={downloadFill} alt="download-fill" width={16} height={16} />
            </Link>
          </li>
        </ol>
      </Modal>
    </div>
  );
}
